import React, { useState } from "react";
import { createCategory } from "../../services/photoCategoryService";

export default function AdminPhotoCategoryForm({ onSuccess }) {
  const [formData, setFormData] = useState({ name: "", photoFile: null });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append("name", formData.name);
    if (formData.photoFile) fd.append("photoFile", formData.photoFile);

    await createCategory(fd);
    onSuccess();
    setFormData({ name: "", photoFile: null });
  };

  return (
    <form onSubmit={handleSubmit} className="p-3 border rounded shadow-sm">
      <h5>Add New Category</h5>
      <div className="mb-3">
        <label className="form-label">Category Name</label>
        <input
          type="text"
          name="name"
          className="form-control"
          value={formData.name}
          onChange={handleChange}
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Category Photo</label>
        <input
          type="file"
          name="photoFile"
          className="form-control"
          accept="image/*"
          onChange={handleChange}
        />
      </div>
      <button type="submit" className="btn btn-primary w-100">
        Save Category
      </button>
    </form>
  );
}
